import * as React from "react";
const SvgSkipNext = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "m6 18 8.5-6L6 6v12zM16 6v12h2V6h-2z",
  fill: "currentColor"
}));
export default SvgSkipNext;